<ng-container *ngIf="activeChannel$ | async as channel; else NO_CHANNEL">
  <mat-sidenav-container (scroll)="onSideNavScroll($event)" [hasBackdrop]="true">
    <!--mobile-->
    <mat-sidenav
      class="visible-lg-down"
      #drawer
      mode="over"
      (openedStart)="drawerOpened = true"
      fixedInViewport
    >
      <x-sidebar-layout>
        <div xHeader *ngIf="showRegion$ | async">
          <x-close-button (click)="toggleDrawer()"></x-close-button>
          <x-region-button (click)="openRegionOverlay()"></x-region-button>
        </div>
        <x-main-menu-tree
          xMenu
          (nodeSelected)="toggleDrawer()"
          *ngIf="menuState$ | async as menuState"
          [nodes]="menuState.nodeTree?.children"
          [activeNodeAscendants]="menuState.activeNodeAscendants"
          [activeNode]="menuState.activeNode"
          [depth]="null"
        ></x-main-menu-tree>

        <x-my-account-menu
          *xIfLoggedIn
          (click)="toggleDrawer()"
          [isMobile]="true"
          [user]="user$ | async"
        ></x-my-account-menu>

        <!--footer-->
        <ng-container xFooter>
          <x-channel-picker (valueChanged)="toggleDrawer()"></x-channel-picker>
          <div class="footer-actions">
            <button *xIfLoggedOut mat-button routerLink="/login">
              <fa-icon icon="sign-in"></fa-icon>
              <ng-container i18n="@@CallToAction.Login">Login</ng-container>
            </button>
            <button *xIfLoggedIn mat-button (click)="logout()" xGoHomeLink>
              <fa-icon icon="sign-out"></fa-icon>
              <ng-container i18n="@@CallToAction.Logout">Logout</ng-container>
            </button>
            <button
              type="button"
              mat-button
              xButtonType="link"
              xNeedHelp
              color="primary"
              (click)="toggleDrawer()"
            >
              <fa-icon icon="question"></fa-icon>
              <span i18n="@@CallToAction.NeedHelp">Help</span>
            </button>
          </div>
        </ng-container>
      </x-sidebar-layout>
    </mat-sidenav>

    <mat-sidenav-content>
      <x-shop-layout>
        <x-shop-header headerStyle="custom-mobile">
          <x-header-layout>
            <!--left actions-->
            <x-channel-picker xActionLeft class="visible-lg-up"></x-channel-picker>
            <button class="visible-lg-down" mat-icon-button xActionLeft (click)="toggleDrawer()">
              <fa-icon icon="bars"></fa-icon>
            </button>

            <!--logo-->
            <x-brand-logo xHeading xGoHomeLink></x-brand-logo>

            <!--right actions-->
            <x-search-button xActionRight class="visible-lg-down"></x-search-button>
            <x-region-select xActionRight *ngIf="showRegion$ | async">
              <x-region-button class="visible-lg-up" xTrigger></x-region-button>
              <x-region-button-icon class="visible-lg-down" xTrigger></x-region-button-icon>
            </x-region-select>
            <div xActionRight class="visible-lg-up">
              <x-logged-in *xIfLoggedIn></x-logged-in>
              <x-logged-out *xIfLoggedOut></x-logged-out>
            </div>
            <x-order-bag-button xActionRight></x-order-bag-button>
          </x-header-layout>
          <x-main-menu class="visible-lg-up"></x-main-menu>
        </x-shop-header>

        <router-outlet xBody></router-outlet>
        <x-shop-footer></x-shop-footer>
      </x-shop-layout>
    </mat-sidenav-content>
  </mat-sidenav-container>
</ng-container>

<ng-template #NO_CHANNEL>
  <x-channel-not-found></x-channel-not-found>
</ng-template>
